import React, { lazy } from 'react';
import { FileSearch } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center pt-24 bg-noir-bg overflow-hidden border-b border-noir-border" data-id="element-61">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#1C1C1C 1px, transparent 1px), linear-gradient(90deg, #1C1C1C 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-62"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pb-16" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          {/* Text Content */}
          <div className="flex flex-col space-y-8" data-id="element-65">
            <div className="inline-flex items-center space-x-2 bg-noir-card border border-noir-border px-3 py-1 w-fit rounded-sm" data-id="element-66">
              <FileSearch className="w-4 h-4 text-noir-alert" data-id="element-67" />
              <span className="text-xs font-bold tracking-widest text-noir-muted uppercase font-mono" data-id="element-68">
                Archivo Confidencial
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-noir-text leading-tight uppercase tracking-tight" data-id="element-69">
              Expediente Pareja: <br data-id="element-70" />
              <span className="text-noir-alert" data-id="element-71">El Juego de los Casos</span>
            </h1>

            <p className="text-lg sm:text-xl text-noir-muted leading-relaxed border-l-2 border-noir-alert pl-4 font-sans" data-id="element-72">
              Resuelvan el misterio de "otros" para salvar el suyo: La
              experiencia digital que rompe el silencio y reconecta a las
              parejas en 48 horas.
            </p>

            {/* Image - single element, responsive wrapper */}
            <div className="relative w-full lg:hidden" data-id="element-73">
              <div className="relative rounded-sm overflow-hidden border border-noir-border bg-noir-card aspect-video shadow-lg" data-id="element-74">
                <img src="https://cdn.magicpatterns.com/uploads/mdHVgH57DtAXRtAyCfscwL/Couple_at_dining_202603260212.jpg" alt="Pareja cenando en silencio" className="w-full h-full object-cover" loading="lazy" data-id="element-75" />
                {/* Corner overlays */}
                <div className="absolute top-4 left-4 w-4 h-4 border-t-2 border-l-2 border-noir-alert z-10" data-id="element-76"></div>
                <div className="absolute top-4 right-4 w-4 h-4 border-t-2 border-r-2 border-noir-alert z-10" data-id="element-77"></div>
                <div className="absolute bottom-4 left-4 w-4 h-4 border-b-2 border-l-2 border-noir-alert z-10" data-id="element-78"></div>
                <div className="absolute bottom-4 right-4 w-4 h-4 border-b-2 border-r-2 border-noir-alert z-10" data-id="element-79"></div>
              </div>
            </div>

            <div className="pt-2 lg:pt-4 flex flex-col items-start space-y-3 w-full" data-id="element-80">
              <a href="#final-cta" onClick={e => {
              e.preventDefault();
              document.getElementById('final-cta')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="inline-flex flex-col items-center justify-center px-8 py-4 text-lg font-bold text-white bg-noir-alert border border-transparent rounded-sm hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-noir-alert focus:ring-offset-noir-bg w-full sm:w-auto uppercase tracking-wider text-center shadow-[0_0_20px_rgba(211,47,47,0.4)]" data-id="element-81">
                <span data-id="element-82">Descargar Expediente</span>
                <span className="text-sm font-normal opacity-90 mt-1 normal-case tracking-normal" data-id="element-83">
                  por sólo $6.36 USD
                </span>
              </a>
            </div>
          </div>

          {/* Desktop Image */}
          <div className="relative mx-auto w-full max-w-2xl lg:max-w-none hidden lg:block" data-id="element-84">
            <div className="relative rounded-sm overflow-hidden border border-noir-border bg-noir-card aspect-video shadow-lg" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/mdHVgH57DtAXRtAyCfscwL/Couple_at_dining_202603260212.jpg" alt="Pareja cenando en silencio" className="w-full h-full object-cover" loading="lazy" data-id="element-86" />
              {/* Corner overlays */}
              <div className="absolute top-4 left-4 w-4 h-4 border-t-2 border-l-2 border-noir-alert z-10" data-id="element-87"></div>
              <div className="absolute top-4 right-4 w-4 h-4 border-t-2 border-r-2 border-noir-alert z-10" data-id="element-88"></div>
              <div className="absolute bottom-4 left-4 w-4 h-4 border-b-2 border-l-2 border-noir-alert z-10" data-id="element-89"></div>
              <div className="absolute bottom-4 right-4 w-4 h-4 border-b-2 border-r-2 border-noir-alert z-10" data-id="element-90"></div>
              <div className="absolute top-4 right-10 flex space-x-1 z-10" data-id="element-91">
                <div className="w-1 h-3 bg-noir-alert animate-pulse" data-id="element-92"></div>
                <div className="w-1 h-3 bg-noir-alert animate-pulse delay-75" data-id="element-93"></div>
                <div className="w-1 h-3 bg-noir-alert animate-pulse delay-150" data-id="element-94"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Do Not Cross Tape */}
      <div className="w-full h-8 bg-[repeating-linear-gradient(45deg,#FFD700,#FFD700_20px,#000_20px,#000_40px)] border-y-2 border-black flex items-center justify-center overflow-hidden mt-auto absolute bottom-0" data-id="element-95">
        <div className="flex space-x-8 whitespace-nowrap" style={{
        animation: 'marquee 20s linear infinite',
        willChange: 'transform'
      }} data-id="element-96">
          {[...Array(6)].map((_, i) => <span key={i} className="text-black font-mono font-bold tracking-[0.2em] text-sm" data-id="element-97">
              CRIME SCENE DO NOT CROSS
            </span>)}
        </div>
      </div>
      <style data-id="element-98">{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}